import { CmsStaticPageView } from '../../../../components/Cms';

export function CmsStaticPageDetail() {
  return <CmsStaticPageView />;
}
